import React from 'react';
import HeadingAndSupportingText from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import { TypographyProps } from 'atoms/Typography/Typography';
import { cssVar } from 'styles/helper';
import { VerticalTextListContainer } from './VerticalTextList.styles';

export interface TextListItem {
  title: string;
  description?: React.ReactNode;
}

export interface VerticalTextListProps {
  titleItemProps?: Omit<TypographyProps, 'children' | 'text'>;
  descriptionItemProps?: Omit<TypographyProps, 'children' | 'text'>;
  items: TextListItem[];
}

const VerticalTextList = ({
  titleItemProps = {
    type: 'heading',
    size: 'xs',
    fontWeight: 'font-weight-semibold',
  },
  descriptionItemProps = {
    type: 'paragraph',
    size: 'lg',
    color: 'text-tertiary',
  },
  items,
}: VerticalTextListProps): JSX.Element => {
  return (
    <VerticalTextListContainer
      direction='column'
      justify='center'
      align='flex-start'
      padding={['spacing-4xl', 'spacing-5xl']}
      paddingSm={['spacing-xl', 'spacing-2xl']}
      gap='spacing-4xl'
      border={`1px solid ${cssVar('border-secondary-alt')}`}
      background='bg-primary'
      borderRadius='radius-2xl'
    >
      {items.map((item, index) => (
        <HeadingAndSupportingText
          key={index}
          heading={{
            ...titleItemProps,
            text: item.title,
          }}
          supportingText={{
            ...descriptionItemProps,
            children: item.description,
          }}
          gap='spacing-sm'
        />
      ))}
    </VerticalTextListContainer>
  );
};

export default VerticalTextList;
